import blueJumper from '../images/blueJumper.jpg';
import brownJumper from '../images/brownJumper.jpg';
import grayJumper from '../images/grayJumper.jpg';
import orangeJumper from '../images/orangeJumper.jpg';
import pinkJumper from '../images/pinkJumper.jpg';
import yellowJumper from '../images/yellowJumper.jpg';
import blackTrousers from '../images/blackTrousers.jpg';
import brownTrousers from '../images/brownTrousers.jpg';
import greyTrousers from '../images/darkGreyTrousers.jpg';
import navyTrousers from '../images/navyTrousers.jpg';
import redTrousers from '../images/redTrousers.jpg';
import yellowTrousers from '../images/yellowTrousers.jpg';
import blueTshirt from '../images/blueTshirt.jpg';
import greenTshirt from '../images/greenTshirt.jpg';
import orangeTshirt from '../images/orangeTshirt.jpg';
import redTshirt from '../images/redTshirt.jpg';
import whiteTshirt from '../images/whiteTshirt.jpg';
import yellowTshirt from '../images/yellowTshirt.jpg';
import blackSkirt from '../images/blackSkirt.jpg';
import brownSkirt from '../images/brownSkirt.jpg';
import flowersSkirt from '../images/flowersSkirt.jpg';
import graySkirt from '../images/graySkirt.jpg';
import tartanSkirt from '../images/tartanSkirt.jpg';
import socks1 from '../images/socks1.jpg';
import socks2 from '../images/socks2.jpg';
import socks3 from '../images/socks3.jpg';
import socks4 from '../images/socks4.jpg';
import socks5 from '../images/socks5.jpg';
import socks6 from '../images/socks6.jpg';

export const ItemsList = [
    {
        id: 1,
        itemName: 'Black Skirt',
        price: 24.00,
        itemImage: blackSkirt,
    },

    {
        id: 2,
        itemName: 'Brown Skirt',
        price: 30.00,
        itemImage: brownSkirt,
    },

    {
        id: 3,
        itemName: 'Flower Skirt',
        price: 12.00,
        itemImage: flowersSkirt,
    },

    {
        id: 4,
        itemName: 'Gray Skirt',
        price: 36.00,
        itemImage: graySkirt,
    },

    {
        id: 5,
        itemName: 'Tartan Skirt',
        price: 21.00,
        itemImage: tartanSkirt,
    },

    {
        id: 6,
        itemName: 'Black Trousers',
        price: 12.00,
        itemImage: blackTrousers,
    },

    {
        id: 7,
        itemName: 'Brown Trousers',
        price: 14.00,
        itemImage: brownTrousers,
    },

    {
        id: 8,
        itemName: 'Grey Trousers',
        price: 20.00,
        itemImage: greyTrousers,
    },


    {
        id: 10,
        itemName: 'Navy-blue Trousers',
        price: 18.00,
        itemImage: navyTrousers,
    },

    {
        id: 11,
        itemName: 'Red Trousers',
        price: 30.00,
        itemImage: redTrousers,
    },

    {
        id: 12,
        itemName: 'Yellow Trousers',
        price: 24.00,
        itemImage: yellowTrousers,
    },

    {
        id: 13,
        itemName: 'Blue T-shirt',
        price: 21.00,
        itemImage: blueTshirt,
    },

    {
        id: 14,
        itemName: 'Green T-shirt',
        price: 20.00,
        itemImage: greenTshirt,
    },

    {
        id: 15,
        itemName: 'Orange T-shirt',
        price: 27.00,
        itemImage: orangeTshirt,
    },

    {
        id: 16,
        itemName: 'Red T-shirt',
        price: 23.50,
        itemImage: redTshirt,
    },

    {
        id: 17,
        itemName: 'White T-shirt',
        price: 21.00,
        itemImage: whiteTshirt,
    },

    {
        id: 18,
        itemName: 'Yellow T-shirt',
        price: 30.00,
        itemImage: yellowTshirt,
    },

    {
        id: 19,
        itemName: 'Blue Jumper',
        price: 36.00,
        itemImage: blueJumper,
    },

    {
        id: 20,
        itemName: 'Brown Jumper',
        price: 32.00,
        itemImage: brownJumper,
    },

    {
        id: 21,
        itemName: 'Gray Jumper',
        price: 42.00,
        itemImage: grayJumper,
    },

    {
        id: 22,
        itemName: 'Orange Jumper',
        price: 37.50,
        itemImage: orangeJumper,
    },

    {
        id: 23,
        itemName: 'Pink Jumper',
        price: 50.00,
        itemImage: pinkJumper,
    },

    {
        id: 24,
        itemName: 'Yellow Jumper',
        price: 48.00,
        itemImage: yellowJumper,
    },

    {
        id: 25,
        itemName: 'Socks - moose',
        price: 9.00,
        itemImage: socks1,
    },

    {
        id: 26,
        itemName: 'Socks - sheep',
        price: 12.00,
        itemImage: socks2,
    },

    {
        id: 27,
        itemName: 'Socks - zebra',
        price: 9.00,
        itemImage: socks3,
    },

    {
        id: 28,
        itemName: 'Socks - fish',
        price: 8.40,
        itemImage: socks4,
    },

    {
        id: 29,
        itemName: 'Socks - foxy',
        price: 12.00,
        itemImage: socks5,
    },

    {
        id: 30,
        itemName: 'Socks - penguin',
        price: 9.50,
        itemImage: socks6,
    },

]